import React, { Component } from 'react';

import Grid from '../Grid';

class ArtistOverview extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      artist: props.artist
    }

  }

  componentWillReceiveProps(newProps) {
    this.setState({artist: newProps.artist});
  }

  render() {

    let artist = this.state.artist;

    return (
 
      <div>
        <Grid title="Top tracks" type="track" playable={true} carousel={true} elements={artist.topTracks} />
        <Grid title="Top albums" type="album" playable={true} carousel={true} elements={artist.topAlbums} />
      </div>
              
    );

  }
}

export default ArtistOverview;



// WEBPACK FOOTER //
// ./src/js/components/artist/ArtistOverview.jsx